import { Grid, Text, Box } from '@simplywallst/ui-core';
import type { TextProps } from '@simplywallst/ui-core';
import { RiskReward } from './RiskReward';

type Severity = 'minor' | 'major' | 'none' | null;

interface Props {
  severity?: Severity;
  description: string;
  typography?: TextProps['typography'];
}

export const RiskRewardStatement = ({
  description,
  severity = null,
  typography = 'small',
}: Props) => (
  <Grid templateColumns="24px auto" alignItems="start" gap="8px">
    <RiskReward severity={severity} />
    {description && (
      <Box marginBottom="x0_5" marginTop="x0_25">
        <Text typography={typography}>{description}</Text>
      </Box>
    )}
  </Grid>
);
